"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertParametersToJavascript = convertParametersToJavascript;
var xOffset;

function convertParametersToJavascript(parameters) {
  var _parameters$Backgroun, _parameters$Other, _parameters$Time, _parameters$Time2, _parameters$Activity, _parameters$Activity2, _parameters$Activity3, _parameters$Activity4, _parameters$Activity5, _parameters$Date, _parameters$Date$Mont, _parameters$Date2, _parameters$Date2$Mon, _parameters$Date3, _parameters$Date3$Mon, _parameters$Date4, _parameters$Date5, _parameters$Date6, _parameters$Date7, _parameters$Weather, _parameters$Weather$I, _parameters$Weather2, _parameters$Weather2$, _parameters$Weather3, _parameters$Weather3$, _parameters$Weather3$2, _parameters$Weather4, _parameters$Weather4$, _parameters$Weather4$2, _parameters$Weather5, _parameters$Weather5$, _parameters$Weather6, _parameters$Weather7, _parameters$Weather8, _parameters$Weather8$, _parameters$Status, _parameters$Status2, _parameters$Status3, _parameters$Battery, _parameters$Battery2, _parameters$Battery3;

  var xOffsetParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  xOffset = xOffsetParam;
  var result = [];
  var updateCalls = '';
  var backgroundImage = (_parameters$Backgroun = parameters.Background) === null || _parameters$Backgroun === void 0 ? void 0 : _parameters$Backgroun.Image;

  if (backgroundImage) {
    result.push("hmUI.createWidget(hmUI.widget.IMG, {x: ".concat(backgroundImage.X + xOffset, ", y: ").concat(backgroundImage.Y, ", src: 'images/").concat(backgroundImage.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL});"));
  }

  var animations = (_parameters$Other = parameters.Other) === null || _parameters$Other === void 0 ? void 0 : _parameters$Other.Animation;

  if (animations) {
    // Pack to list if not a list
    if (!Array.isArray(animations)) {
      animations = [animations];
    }

    animations.forEach(function (animation, i) {
      var animationImages = animation.AnimationImages;
      result.push("hmUI.createWidget(hmUI.widget.IMG_ANIM, { x: ".concat(animationImages.X + xOffset, ", y: ").concat(animationImages.Y, ", anim_path: 'images', anim_prefix: 'anim").concat(i, "', anim_ext: 'png',anim_fps: ").concat(Math.round(1000 / animation.Speed), ", anim_size: ").concat(animationImages.ImagesCount, ", repeat_count: ").concat(animation.RepeatCount, ", anim_repeat: ").concat(animation.RepeatCount > 0, ", anim_status: hmUI.anim_status.START, show_level: hmUI.show_level.ONLY_NORMAL })"));
    });
  }

  var time = parameters.Time;

  if (time) {
    result.push("timeHourTensFontArray = ".concat(createImageArray(time.Hours.Tens)));
    result.push("timeHourOnesFontArray = ".concat(createImageArray(time.Hours.Ones)));
    result.push("timeMinutesTensFontArray = ".concat(createImageArray(time.Minutes.Tens)));
    result.push("timeMinutesOnesFontArray = ".concat(createImageArray(time.Minutes.Ones)));
    result.push("timeHourTens = hmUI.createWidget(hmUI.widget.IMG, { x: ".concat(time.Hours.Tens.X + xOffset, ", y: ").concat(time.Hours.Tens.Y, ", src: 'images/").concat(time.Hours.Tens.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL })"));
    result.push("timeHourOnes = hmUI.createWidget(hmUI.widget.IMG, { x: ".concat(time.Hours.Ones.X + xOffset, ", y: ").concat(time.Hours.Ones.Y, ", src: 'images/").concat(time.Hours.Ones.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL })"));
    result.push("timeMinutesTens = hmUI.createWidget(hmUI.widget.IMG, { x: ".concat(time.Minutes.Tens.X + xOffset, ", y: ").concat(time.Minutes.Tens.Y, ", src: 'images/").concat(time.Minutes.Tens.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL })"));
    result.push("timeMinutesOnes = hmUI.createWidget(hmUI.widget.IMG, { x: ".concat(time.Minutes.Ones.X + xOffset, ", y: ").concat(time.Minutes.Ones.Y, ", src: 'images/").concat(time.Minutes.Ones.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL })"));
    updateCalls += "updateTime();";
    var delimiterImage = time.DelimiterImage || time.TimeDelimiterImage;

    if (delimiterImage) {
      result.push("hmUI.createWidget(hmUI.widget.IMG, {x: ".concat(delimiterImage.X + xOffset, ", y: ").concat(delimiterImage.Y, ", src: 'images/").concat(delimiterImage.ImageIndex, ".png', show_level: hmUI.show_level.ONLY_NORMAL});"));
    }
  }

  var sunriseTime = (_parameters$Time = parameters.Time) === null || _parameters$Time === void 0 ? void 0 : _parameters$Time.SunriseTimeNumber;

  if (sunriseTime) {
    result.push(createNumber(time, 'SUN_RISE', "SunriseTime"));
  }

  var sunsetTime = (_parameters$Time2 = parameters.Time) === null || _parameters$Time2 === void 0 ? void 0 : _parameters$Time2.SunsetTimeNumber;

  if (sunsetTime) {
    result.push(createNumber(time, 'SUN_SET', "SunsetTime"));
  }

  var steps = (_parameters$Activity = parameters.Activity) === null || _parameters$Activity === void 0 ? void 0 : _parameters$Activity.Steps;

  if (steps) {
    result.push(createNumber(steps, 'STEP'));
  }

  var calories = (_parameters$Activity2 = parameters.Activity) === null || _parameters$Activity2 === void 0 ? void 0 : _parameters$Activity2.Calories;

  if (calories) {
    result.push(createNumber(calories, 'CAL'));
  }

  var pulse = (_parameters$Activity3 = parameters.Activity) === null || _parameters$Activity3 === void 0 ? void 0 : _parameters$Activity3.Pulse;

  if (pulse) {
    result.push(createNumber(pulse, 'HEART'));
  }

  var distance = (_parameters$Activity4 = parameters.Activity) === null || _parameters$Activity4 === void 0 ? void 0 : _parameters$Activity4.Distance;

  if (distance) {
    result.push(createNumber(distance, 'DISTANCE'));
  }

  var pai = (_parameters$Activity5 = parameters.Activity) === null || _parameters$Activity5 === void 0 ? void 0 : _parameters$Activity5.PAI;

  if (pai) {
    result.push(createNumber(pai, 'PAI_WEEKLY'));
  }

  var dateSeparate = (_parameters$Date = parameters.Date) === null || _parameters$Date === void 0 ? void 0 : (_parameters$Date$Mont = _parameters$Date.MonthAndDayAndYear) === null || _parameters$Date$Mont === void 0 ? void 0 : _parameters$Date$Mont.Separate;

  if (dateSeparate) {
    var dateParams = [];
    var month = dateSeparate.Month;

    if (month) {
      dateParams.push("month_startX: ".concat(month.TopLeftX + xOffset));
      dateParams.push("month_startY: ".concat(month.TopLeftY));
      dateParams.push("month_align: ".concat(getAlignHAndPosition(month).alignment));
      dateParams.push("month_space: ".concat(month.SpacingX));
      dateParams.push("month_zero: ".concat(parameters.Date.MonthAndDayAndYear.TwoDigitsMonth));
      dateParams.push("month_en_array: ".concat(createImageArray(month)));
      dateParams.push("month_sc_array: ".concat(createImageArray(month)));
      dateParams.push("month_tc_array: ".concat(createImageArray(month)));
    } else {
      var monthsEn = dateSeparate.MonthsEN;
      var monthsCn = dateSeparate.MonthsCN;
      var monthChar = monthsEn || monthsCn;

      if (monthChar) {
        dateParams.push("month_startX: ".concat(monthChar.X + xOffset));
        dateParams.push("month_startY: ".concat(monthChar.Y));

        if (monthsEn) {
          dateParams.push("month_en_array: ".concat(createImageArray(monthsEn)));
        }

        if (monthsCn) {
          dateParams.push("month_sc_array: ".concat(createImageArray(monthsCn)));
          dateParams.push("month_tc_array: ".concat(createImageArray(monthsCn)));
        }

        dateParams.push("month_is_character: true");
      }
    }

    var day = dateSeparate.Day;

    if (day) {
      dateParams.push("day_startX: ".concat(day.TopLeftX + xOffset));
      dateParams.push("day_startY: ".concat(day.TopLeftY));
      dateParams.push("day_align: ".concat(getAlignHAndPosition(day).alignment));
      dateParams.push("day_space: ".concat(day.SpacingX));
      dateParams.push("day_zero: ".concat(parameters.Date.MonthAndDayAndYear.TwoDigitsDay));
      dateParams.push("day_en_array: ".concat(createImageArray(day)));
      dateParams.push("day_sc_array: ".concat(createImageArray(day)));
      dateParams.push("day_tc_array: ".concat(createImageArray(day)));
    }

    result.push("hmUI.createWidget(hmUI.widget.IMG_DATE,{".concat(dateParams.join(','), ",show_level: hmUI.show_level.ONLY_NORMAL})"));
  }

  var dateOneLineWithYear = (_parameters$Date2 = parameters.Date) === null || _parameters$Date2 === void 0 ? void 0 : (_parameters$Date2$Mon = _parameters$Date2.MonthAndDayAndYear) === null || _parameters$Date2$Mon === void 0 ? void 0 : _parameters$Date2$Mon.OneLineWithYear;
  var dateOneLine = dateOneLineWithYear || ((_parameters$Date3 = parameters.Date) === null || _parameters$Date3 === void 0 ? void 0 : (_parameters$Date3$Mon = _parameters$Date3.MonthAndDayAndYear) === null || _parameters$Date3$Mon === void 0 ? void 0 : _parameters$Date3$Mon.OneLine);

  if (dateOneLine) {
    var _dateParams = [];
    var number = dateOneLine.Number;

    if (dateOneLineWithYear) {
      _dateParams.push("year_startX: ".concat(number.TopLeftX + xOffset));

      _dateParams.push("year_startY: ".concat(number.TopLeftY));

      _dateParams.push("year_align: ".concat(getAlignHAndPosition(number).alignment));

      _dateParams.push("year_space: ".concat(number.SpacingX));

      _dateParams.push("year_unit_en:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

      _dateParams.push("year_unit_sc:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

      _dateParams.push("year_unit_tc:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

      _dateParams.push("year_en_array: ".concat(createImageArray(number)));

      _dateParams.push("year_sc_array: ".concat(createImageArray(number)));

      _dateParams.push("year_tc_array: ".concat(createImageArray(number)));

      _dateParams.push("year_zero: true");

      _dateParams.push("month_follow: true");
    } else {
      _dateParams.push("month_startX: ".concat(number.TopLeftX + xOffset));

      _dateParams.push("month_startY: ".concat(number.TopLeftY));
    }

    _dateParams.push("month_align: ".concat(getAlignHAndPosition(number).alignment));

    _dateParams.push("month_space: ".concat(number.SpacingX));

    _dateParams.push("month_zero: ".concat(parameters.Date.MonthAndDayAndYear.TwoDigitsMonth));

    _dateParams.push("month_unit_en:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

    _dateParams.push("month_unit_sc:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

    _dateParams.push("month_unit_tc:'images/".concat(dateOneLine.DelimiterImageIndex, ".png'"));

    _dateParams.push("month_en_array: ".concat(createImageArray(number)));

    _dateParams.push("month_sc_array: ".concat(createImageArray(number)));

    _dateParams.push("month_tc_array: ".concat(createImageArray(number)));

    _dateParams.push("day_follow: true");

    _dateParams.push("day_align: ".concat(getAlignHAndPosition(number).alignment));

    _dateParams.push("day_space: ".concat(number.SpacingX));

    _dateParams.push("day_zero: ".concat(parameters.Date.MonthAndDayAndYear.TwoDigitsDay));

    _dateParams.push("day_en_array: ".concat(createImageArray(number)));

    _dateParams.push("day_sc_array: ".concat(createImageArray(number)));

    _dateParams.push("day_tc_array: ".concat(createImageArray(number)));

    result.push("hmUI.createWidget(hmUI.widget.IMG_DATE,{".concat(_dateParams.join(','), ",show_level: hmUI.show_level.ONLY_NORMAL})"));
  }

  var dayAmPm = (_parameters$Date4 = parameters.Date) === null || _parameters$Date4 === void 0 ? void 0 : _parameters$Date4.DayAmPm;

  if (dayAmPm) {
    result.push("hmUI.createWidget(hmUI.widget.IMG_TIME, {am_x:".concat(dayAmPm.X + xOffset, ",am_y:").concat(dayAmPm.Y, ",pm_x:").concat(dayAmPm.X + xOffset, ",pm_y:").concat(dayAmPm.Y, ",am_en_path:'images/").concat(dayAmPm.ImageIndexAMEN, ".png',pm_en_path:'images/").concat(dayAmPm.ImageIndexPMEN, ".png',am_sc_path:'images/").concat(dayAmPm.ImageIndexAMCN, ".png',pm_sc_path:'images/").concat(dayAmPm.ImageIndexPMCN, ".png',show_level: hmUI.show_level.ONLY_NORMAL})"));
  }

  var enWeekDays = (_parameters$Date5 = parameters.Date) === null || _parameters$Date5 === void 0 ? void 0 : _parameters$Date5.ENWeekDays;
  var tcWeekDays = (_parameters$Date6 = parameters.Date) === null || _parameters$Date6 === void 0 ? void 0 : _parameters$Date6.CNWeekDays;
  var scWeekDays = (_parameters$Date7 = parameters.Date) === null || _parameters$Date7 === void 0 ? void 0 : _parameters$Date7.CN2WeekDays;
  var weekDays = enWeekDays || tcWeekDays || scWeekDays;

  if (weekDays) {
    result.push("hmUI.createWidget(hmUI.widget.IMG_WEEK, {x:".concat(weekDays.X + xOffset, ",y:").concat(weekDays.Y, ",week_en:").concat(createImageArray(enWeekDays), ",week_sc:").concat(createImageArray(scWeekDays), ",week_tc:").concat(createImageArray(tcWeekDays), ",show_level: hmUI.show_level.ONLY_NORMAL})"));
  }

  var weatherIcon = (_parameters$Weather = parameters.Weather) === null || _parameters$Weather === void 0 ? void 0 : (_parameters$Weather$I = _parameters$Weather.Icon) === null || _parameters$Weather$I === void 0 ? void 0 : _parameters$Weather$I.CustomIcon;

  if (weatherIcon) {
    result.push("hmUI.createWidget(hmUI.widget.IMG_LEVEL,{x:".concat(weatherIcon.X + xOffset, ",y:").concat(weatherIcon.Y, ",image_array:").concat(createWeatherArray(weatherIcon), ",image_length:29,type:hmUI.data_type.WEATHER,show_level:hmUI.show_level.ONLY_NORMAL})"));
  }

  var weatherTemperatureCurrent = (_parameters$Weather2 = parameters.Weather) === null || _parameters$Weather2 === void 0 ? void 0 : (_parameters$Weather2$ = _parameters$Weather2.Temperature) === null || _parameters$Weather2$ === void 0 ? void 0 : _parameters$Weather2$.Current;

  if (weatherTemperatureCurrent) {
    result.push(createNumber(weatherTemperatureCurrent, 'WEATHER_CURRENT'));
  }

  var weatherTemperatureTodayOneLine = (_parameters$Weather3 = parameters.Weather) === null || _parameters$Weather3 === void 0 ? void 0 : (_parameters$Weather3$ = _parameters$Weather3.Temperature) === null || _parameters$Weather3$ === void 0 ? void 0 : (_parameters$Weather3$2 = _parameters$Weather3$.Today) === null || _parameters$Weather3$2 === void 0 ? void 0 : _parameters$Weather3$2.OneLine;

  if (weatherTemperatureTodayOneLine) {
    result.push("weatherWidget = ".concat(createNumber(weatherTemperatureTodayOneLine)));
    updateCalls += 'updateWeather();';
  }

  var weatherTemperatureTodaySeparate = (_parameters$Weather4 = parameters.Weather) === null || _parameters$Weather4 === void 0 ? void 0 : (_parameters$Weather4$ = _parameters$Weather4.Temperature) === null || _parameters$Weather4$ === void 0 ? void 0 : (_parameters$Weather4$2 = _parameters$Weather4$.Today) === null || _parameters$Weather4$2 === void 0 ? void 0 : _parameters$Weather4$2.Separate;

  if (weatherTemperatureTodaySeparate) {
    var _day = weatherTemperatureTodaySeparate.Day;

    if (_day) {
      result.push(createNumber(_day, 'WEATHER_HIGH'));
    }

    var night = weatherTemperatureTodaySeparate.Night;

    if (night) {
      result.push(createNumber(night, 'WEATHER_LOW'));
    }
  }

  var airQualityIcon = (_parameters$Weather5 = parameters.Weather) === null || _parameters$Weather5 === void 0 ? void 0 : (_parameters$Weather5$ = _parameters$Weather5.AirQuality) === null || _parameters$Weather5$ === void 0 ? void 0 : _parameters$Weather5$.Icon;

  if (airQualityIcon) {
    result.push("hmUI.createWidget(hmUI.widget.IMG_LEVEL,{x:".concat(airQualityIcon.X + xOffset, ",y:").concat(airQualityIcon.Y, ",image_array:").concat(createWeatherArray(airQualityIcon), ",image_length:").concat(airQualityIcon.ImagesCount, ",type:hmUI.data_type.AQI,show_level:hmUI.show_level.ONLY_NORMAL})"));
  }

  var humidity = (_parameters$Weather6 = parameters.Weather) === null || _parameters$Weather6 === void 0 ? void 0 : _parameters$Weather6.Humidity;

  if (humidity) {
    result.push(createNumber(humidity, 'HUMIDITY'));
  }

  var wind = (_parameters$Weather7 = parameters.Weather) === null || _parameters$Weather7 === void 0 ? void 0 : _parameters$Weather7.Wind;

  if (wind) {
    result.push(createNumber(wind, 'WIND'));
  }

  var uv = (_parameters$Weather8 = parameters.Weather) === null || _parameters$Weather8 === void 0 ? void 0 : (_parameters$Weather8$ = _parameters$Weather8.UVIndex) === null || _parameters$Weather8$ === void 0 ? void 0 : _parameters$Weather8$.UV;

  if (uv) {
    result.push(createNumber(uv, 'UVI'));
  }

  createProgress(parameters.StepsProgress, 'STEP', result);
  createProgress(parameters.HeartProgress, 'HEART', result);
  createProgress(parameters.CaloriesProgress, 'CAL', result);
  var doNotDisturb = (_parameters$Status = parameters.Status) === null || _parameters$Status === void 0 ? void 0 : _parameters$Status.DoNotDisturb;

  if (doNotDisturb) {
    var coordinates = doNotDisturb.Coordinates;
    result.push("hmUI.createWidget(hmUI.widget.IMG_STATUS,{x:".concat(coordinates.X + xOffset, ",y:").concat(coordinates.Y, ",src: 'images/").concat(doNotDisturb.OnImageIndex, ".png',type:hmUI.system_status.DISTURB,show_level:hmUI.show_level.ONLY_NORMAL})"));
  }

  var lock = (_parameters$Status2 = parameters.Status) === null || _parameters$Status2 === void 0 ? void 0 : _parameters$Status2.Lock;

  if (lock) {
    var _coordinates = lock.Coordinates;
    result.push("hmUI.createWidget(hmUI.widget.IMG_STATUS,{x:".concat(_coordinates.X + xOffset, ",y:").concat(_coordinates.Y, ",src: 'images/").concat(lock.OffImageIndex, ".png',type:hmUI.system_status.LOCK,show_level:hmUI.show_level.ONLY_NORMAL})"));
  }

  var bluetooth = (_parameters$Status3 = parameters.Status) === null || _parameters$Status3 === void 0 ? void 0 : _parameters$Status3.Bluetooth;

  if (bluetooth) {
    var _coordinates2 = bluetooth.Coordinates;
    result.push("hmUI.createWidget(hmUI.widget.IMG_STATUS,{x:".concat(_coordinates2.X + xOffset, ",y:").concat(_coordinates2.Y, ",src: 'images/").concat(bluetooth.OffImageIndex, ".png',type:hmUI.system_status.DISCONNECT,show_level:hmUI.show_level.ONLY_NORMAL})"));
  }

  var alarm = parameters.Alarm;

  if (alarm) {
    var alarmIcon = alarm.OnImage;

    if (alarmIcon) {
      result.push("hmUI.createWidget(hmUI.widget.IMG_STATUS,{x:".concat(alarmIcon.X + xOffset, ",y:").concat(alarmIcon.Y, ",src:'images/").concat(alarmIcon.ImageIndex, ".png',type:hmUI.system_status.CLOCK,show_level:hmUI.show_level.ONLY_NORMAL})"));
    }

    var alarmNumber = alarm.Number;

    if (alarmNumber) {
      result.push(createNumber(alarm, 'ALARM_CLOCK'));
    }
  }

  var batteryText = (_parameters$Battery = parameters.Battery) === null || _parameters$Battery === void 0 ? void 0 : _parameters$Battery.BatteryText;

  if (batteryText) {
    result.push(createNumber(batteryText, 'BATTERY'));
  }

  var batteryIcon = (_parameters$Battery2 = parameters.Battery) === null || _parameters$Battery2 === void 0 ? void 0 : _parameters$Battery2.BatteryIcon;

  if (batteryIcon) {
    result.push(createProgressLine(batteryIcon, 'BATTERY'));
  }

  var batteryLinear = (_parameters$Battery3 = parameters.Battery) === null || _parameters$Battery3 === void 0 ? void 0 : _parameters$Battery3.Linear;

  if (batteryLinear) {
    result.push(createProgressLinear(batteryLinear, 'BATTERY'));
  }

  if (updateCalls) {
    result.push(updateCalls);
    result.push("hmUI.createWidget(hmUI.widget.WIDGET_DELEGATE, { resume_call: (function () {".concat(updateCalls, " }) })"));
    result.push("timer.createTimer(0, 1000, (function (option) {".concat(updateCalls, " }))"));
  }

  return result.join('\n');
}

function createProgress(parameter, type, result) {
  var linear = parameter === null || parameter === void 0 ? void 0 : parameter.Linear;

  if (linear) {
    result.push(createProgressLinear(linear, type));
  }

  var line = parameter === null || parameter === void 0 ? void 0 : parameter.LineScale;

  if (line) {
    result.push(createProgressLine(line, type));
  }

  var circle = parameter === null || parameter === void 0 ? void 0 : parameter.CircleScale;

  if (circle) {
    result.push(createProgressCircle(circle, type));
  }
}

function createProgressLine(progress, type) {
  return "hmUI.createWidget(hmUI.widget.IMG_LEVEL,{x:".concat(progress.X + xOffset, ",y:").concat(progress.Y, ",image_array:").concat(createImageArray(progress), ",image_length:").concat(progress.ImagesCount, ",type:hmUI.data_type.").concat(type, ",show_level:hmUI.show_level.ONLY_NORMAL})");
}

function createProgressLinear(progress, type) {
  var StartImageIndex = progress.StartImageIndex,
      Segments = progress.Segments;
  return "hmUI.createWidget(hmUI.widget.IMG_PROGRESS,{x:[".concat(Segments.map(function (c) {
    return c.X + xOffset;
  }).join(','), "],y:[").concat(Segments.map(function (c) {
    return c.Y;
  }).join(','), "],image_array:").concat(createImageArray({
    ImageIndex: StartImageIndex,
    ImagesCount: Segments.length
  }), ",image_length:").concat(Segments.length, ",type:hmUI.data_type.").concat(type, ",show_level:hmUI.show_level.ONLY_NORMAL})");
}

function createProgressCircle(progress, type) {
  return "hmUI.createWidget(hmUI.widget.ARC_PROGRESS,{center_x:".concat(progress.CenterX + xOffset, ",center_y:").concat(progress.CenterY, ",radius:").concat(progress.RadiusX, ",start_angle:").concat(progress.StartAngle, ",end_angle:").concat(progress.EndAngle, ",line_width:").concat(progress.Width, ",color:").concat(progress.Color, ",type:hmUI.data_type.").concat(type, ",show_level:hmUI.show_level.ONLY_NORMAL})");
}

function createNumber(param) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var number = param["".concat(prefix, "Number")];
  var optionalParams = '';

  if (type) {
    optionalParams += ", type: hmUI.data_type.".concat(type);
  }

  if (param.SuffixImageIndex) {
    optionalParams += ", unit_en: 'images/".concat(param.SuffixImageIndex, ".png'");
    optionalParams += ", unit_sc: 'images/".concat(param.SuffixImageIndex, ".png'");
    optionalParams += ", unit_tc: 'images/".concat(param.SuffixImageIndex, ".png'");
  }

  if (param.SuffixImageIndexEN) {
    optionalParams += ", unit_en: 'images/".concat(param.SuffixImageIndexEN, ".png'");
  }

  if (param.SuffixImageIndexCN) {
    optionalParams += ", unit_tc: 'images/".concat(param.SuffixImageIndexCN, ".png'");
  }

  if (param.SuffixImageIndexCN2) {
    optionalParams += ", unit_sc: 'images/".concat(param.SuffixImageIndexCN2, ".png'");
  }

  if (param.NoDataImageIndex) {
    optionalParams += ", invalid_image: 'images/".concat(param.NoDataImageIndex, ".png'");
  }

  var noDataImage = param["".concat(prefix, "NoDataImage")];

  if (noDataImage) {
    optionalParams += ", invalid_image: 'images/".concat(noDataImage.ImageIndex, ".png'");
  }

  if (param.KmSuffixImageIndex) {
    optionalParams += ", unit_en: 'images/".concat(param.KmSuffixImageIndex, ".png'");
    optionalParams += ", unit_sc: 'images/".concat(param.KmSuffixImageIndex, ".png'");
    optionalParams += ", unit_tc: 'images/".concat(param.KmSuffixImageIndex, ".png'");
  }

  if (param.MilesSuffixImageIndex) {
    optionalParams += ", imperial_unit_en: 'images/".concat(param.MilesSuffixImageIndex, ".png'");
    optionalParams += ", imperial_unit_sc: 'images/".concat(param.MilesSuffixImageIndex, ".png'");
    optionalParams += ", imperial_unit_tc: 'images/".concat(param.MilesSuffixImageIndex, ".png'");
  }

  if (param.DecimalPointImageIndex) {
    optionalParams += ", dot_image: 'images/".concat(param.DecimalPointImageIndex, ".png'");
  }

  if (param.MinusImageIndex) {
    optionalParams += ", negative_image: 'images/".concat(param.MinusImageIndex, ".png'");
  }

  var delimiterImageIndex = param["".concat(prefix, "DelimiterImageIndex")];

  if (delimiterImageIndex) {
    optionalParams += ", dot_image: 'images/".concat(delimiterImageIndex, ".png'");
  }

  if (type == "ALARM_CLOCK") {
    optionalParams += ", padding: true";
  } // Compute position


  var _getAlignHAndPosition = getAlignHAndPosition(number),
      alignment = _getAlignHAndPosition.alignment,
      x = _getAlignHAndPosition.x,
      w = _getAlignHAndPosition.w;

  if (w != undefined) {
    optionalParams += ", w: ".concat(w);
  }

  return "hmUI.createWidget(hmUI.widget.TEXT_IMG, { x: ".concat(x + xOffset, ", y: ").concat(number.TopLeftY, ", h_space: ").concat(number.SpacingX, ", font_array: ").concat(createImageArray(number), ", align_h: ").concat(alignment).concat(optionalParams, ", show_level: hmUI.show_level.ONLY_NORMAL})");
}

function createImageArray(arrayInfo) {
  if (!arrayInfo) {
    return;
  }

  var result = [];

  for (var i = 0; i < arrayInfo.ImagesCount; i++) {
    result.push("'images/".concat(arrayInfo.ImageIndex + i, ".png'"));
  }

  return "[".concat(result.join(', '), "]");
}

function createWeatherArray(weather) {
  var result = [];

  for (var i = 1; i <= weather.ImagesCount; i++) {
    result.push("'images/".concat(weather.ImageIndex + i, ".png'"));
  }

  result.push("'images/".concat(weather.ImageIndex + 5, ".png'"));
  result.push("'images/".concat(weather.ImageIndex + 1, ".png'"));
  result.push("'images/".concat(weather.ImageIndex + 6, ".png'"));
  result.push("'images/".concat(weather.ImageIndex + 4, ".png'"));
  return "[".concat(result.join(', '), "]");
}

function getAlignHAndPosition(number) {
  var alignment = number.Alignment; // Fix alignment

  if (number.BottomRightX - number.TopLeftX < 20) {
    alignment = 'Left';
  }

  switch (alignment) {
    case 'Right':
    case 'TopRight':
    case 'BottomRight':
    case 'CenterRight':
      return {
        alignment: 'hmUI.align.RIGHT',
        x: 0,
        w: number.BottomRightX
      };

    case 'HCenter':
    case 'TopCenter':
    case 'BottomCenter':
    case 'Center':
      var center = (number.TopLeftX + number.BottomRightX) / 2;
      var halfWidth = Math.min(center, 152 - center);
      return {
        alignment: 'hmUI.align.CENTER_H',
        x: center - halfWidth,
        w: 2 * halfWidth
      };

    case 'Left':
    case 'TopLeft':
    case 'CenterLeft':
    case 'BottomLeft':
    case 'Top':
    case 'Bottom':
    case 'VCenter':
    default:
      return {
        alignment: 'hmUI.align.LEFT',
        x: number.TopLeftX
      };
  }
}